import { axios } from './axios';

import { OrderProduct } from '@/pages/types';

export const getProductItems = async (productCode: OrderProduct['code'], country: string) => {
  return axios.get(`/products/${productCode}?country=${country}`);
};
